// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function LinearLoading() {

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
      <Box sx={{
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '25%',
        height: '50px',
      }}>
        <LinearProgress sx={{ width: '100%', backgroundColor: '#ff7300', "& .MuiLinearProgress-barColorPrimary": { backgroundColor: '#ffd1bf' } }} />
      </Box>
      <Box sx={{
        marginTop: '-20px',
      }}>
        <Typography variant="body1" color="textSecondary">Loading...</Typography>
      </Box>
    </Box>
  );
}

export default LinearLoading;
